import { Injectable } from '@angular/core';
import clarity from '@microsoft/clarity';

export type ClarityEventName = 'Export first 200' | 'Submit delivery' | 'Cancel order' | `Export - ${string}`;

@Injectable({
  providedIn: 'root',
})
export class ClarityService {
  event(eventName: ClarityEventName): void {
    if (typeof (globalThis as typeof globalThis & { clarity?: unknown }).clarity === 'function') {
      clarity.event(eventName);
    }
  }
}
